import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page29() {
  useEffect(() => {
    document.title = "Маяк — Страница 28"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page27" />
        <ForwardLink href="/page29" />
      </div>

      <p style={{ textAlign: "right" }}>28.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Не дергайся!
      </p>

      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я--
      </p>
      <p>
        СЛОМАННОЕ КОЛЕСО ШКИВА ВЫЛЕТАЕТ... веревка пружинит<br/>
        назад...
      </p>
      <p>
        МОЛОДОЙ, стул, крепеж и страховка падают<br/>
        на землю!
      </p>
      <p>ЧЕРНЫЙ ЭКРАН.</p>
      <br/>
      <p>СНАРУЖИ. ПОДНОЖИЕ БАШНИ МАЯКА – ПОЗЖЕ</p>
      <p>МОЛОДОЙ приходит в себя...</p>
      <p>Он весь в побелке.</p>
      <p>
        Как долго он был в отключке? Он осматривается вокруг... КУХОННЫЙ СТУЛ<br/>
        сломан -- годится только на растопку... СТАРИКА нигде не<br/>
        видно...
      </p>
      <p>
        Одноглазая ЧАЙКА сидит на ноге.<br/>
        Она клюет его, выклевывая свежее мясо.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Брысь.
      </p>
      <p>
        Она клюет снова. ТУК. ТУК. ТУК. По его ноге. ЧАЙКА<br/>
        издает враждебный звук
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Ты! Мерзавка!
      </p>
      <p>Она упорствует, клюя острым клювом.</p>
      <p>МОЛОДОЙ боится птицы. Боится навредить ей...</p>
      <p>ТУК. ТУК. ТУК. Проклятие! Это больно!</p>
      <p>МОЛОДОЙ СИЛЬНО ПИНАЕТ ЕЕ!</p>
      <p>ЧАЙКА улетает, издеваясь над ним мяуканьем</p>
      <p style={{ textAlign: "right" }}>28.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page27" />
        <ForwardLink href="/page29" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710019701/the-lighthouse-script/pihmayncpslryynt4ioe.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page29;
